import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { localeStrings as strings } from 'applicationConfig';
import DocumentationGrid from './DocumentationGrid';

import './documentation.scss';

@inject('documentationStore')
@observer
class Documentation extends Component {

  get links() {
    return this.props.documentationStore.links;
  }

  get items() {
    return this.links.map(link => ({
      text: link.text,
      href: link.href
    }));
  }

  componentDidMount() {
    this.props.documentationStore.loadLinks();
  }

  render() {
    return (
      <div className="documentation-page">
        <div className="documentation-body">
          <p>{strings.documentation.documentationDescription}</p>
          <DocumentationGrid data={this.items} />
        </div>
      </div>
    );
  }
}
export default Documentation;



// WEBPACK FOOTER //
// ./src/containers/Documentation/Documentation.jsx